module.exports = __webpack_public_path__ + "img/step5-03.b720325f.jpg";